import { z } from '@/lib/zod'

export function ManageApiUsageSchema() {
  return z.object({
    apiUser: z.boolean(),
  })
}

export type ManageApiUsageForm = z.infer<
  ReturnType<typeof ManageApiUsageSchema>
>
